// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9f-3";
export var contentContainer = "_9f-0";
export var editorContainer = "_9f-1";
export var quillInputForm = "_9f-2";
export var zoneDivider = "_9f-4";